import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import moment from 'moment';

const LicenseExpiredModal = ({ expirationDate, isOpen, onClose }) => {
  if (!isOpen) return null;

  const daysLeft = moment(expirationDate, 'DD/MM/YYYY').diff(moment(), 'days');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-[90%] max-w-lg text-center animate-fadeIn">
        {/* Alert Header */}
        <div className="flex items-center justify-center text-red-600 mb-4">
          <FaExclamationTriangle className="text-3xl mr-2" />
          <h2 className="text-2xl font-bold">License Expiring Soon</h2>
        </div>

        {/* Message */}
        <p className="text-gray-800 mb-4 leading-relaxed">
          Your license will expire on <strong>{expirationDate}</strong>.
          <br />
          You have{' '}
          <span className="text-red-500 font-bold">
            {daysLeft} day{daysLeft !== 1 && 's'}
          </span>{' '}
          left.
        </p>

        {/* Support Info */}
        <p className="text-gray-700 text-sm mb-6">
          Contact <span className="font-medium">support@geniusoffice.com</span>{' '}
          or call <span className="font-medium">+91 85589 51962</span> to renew
          your license.
          <br />
          Visit{' '}
          <a
            href="https://www.geniusoffice.com"
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.geniusoffice.com
          </a>
        </p>

        {/* Button */}
        <button
          onClick={onClose}
          className="mt-2 bg-red-500 hover:bg-red-700 text-white w-full px-6 py-2 rounded-lg transition font-semibold"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default LicenseExpiredModal;
